import { render, staticRenderFns } from "./GlobalSalesCard.vue?vue&type=template&id=0894588d&"
import script from "./GlobalSalesCard.vue?vue&type=script&lang=js&"
export * from "./GlobalSalesCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0894588d')) {
      api.createRecord('0894588d', component.options)
    } else {
      api.reload('0894588d', component.options)
    }
    module.hot.accept("./GlobalSalesCard.vue?vue&type=template&id=0894588d&", function () {
      api.rerender('0894588d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cards/GlobalSalesCard.vue"
export default component.exports